const { version } = require('../../package.json')

const env = process.env.REACT_APP_DEVELOPMENT || 'STG'
const isStg = env === 'STG'
const isPrd = env === 'PRD'

const STG_GOOGLE_MAP_KEY = 'AIzaSyBFTwcvDlhDpCk82Pq5gvZRz-QS1WnF5DA'
const PRD_GOOGLE_MAP_KEY = 'AIzaSyBM_hCJISW5_g8HFHm5HdgKsPJf4S5QpOg'
const GOOGLE_MAP_API_KEY = isStg ? STG_GOOGLE_MAP_KEY : PRD_GOOGLE_MAP_KEY

const REGION = {
  PHNOM_PENH: 'pnh',
  SIEM_REAP: 'rep',
}

export default {
  REGION,
  version,
  env,
  isStg,
  isPrd,
  GOOGLE_MAP_API_KEY,
  GOOGLE_MAP_URL: `https://maps.googleapis.com/maps/api/js?key=${GOOGLE_MAP_API_KEY}`,
}



// WEBPACK FOOTER //
// ./src/utils/constants.js